<div class="flex flex-wrap">
    <div class="desktop:flex-[1] min-w-[300px] min-h-[500px] mobile:h-[500px]">
        <iframe *ngIf="safePdfUrl" [src]="safePdfUrl" width="100%" height="100%" frameborder="0" style="border: none;">
        </iframe>
    </div>
    <div class="desktop:flex-[1] min-w-[300px] min-h-[500px] mobile:h-auto flex flex-col gap-2">
        <p class="font-bold text-xl py-5">{{ 'admin.ai_analysis' | transloco }}</p>

        <!-- Loading -->
        @if (loadingInvoices) {
        <div class="flex justify-center py-8">
            <span class="loading loading-spinner loading-lg"></span>
        </div>
        }

        @if (!loadingInvoices && firstInvoice) {
        <div class="w-full">
            <app-company-information [invoice]="firstInvoice" [toast]="toast"
                [commodityType]="CommodityType.gas" [successCallbackFunction]="hardReloadCallbackFunction"
                [listOfLocations]="listOfLocations"></app-company-information>
        </div>

        <!-- Single invoice (mensile) -->
        @if (!isMultiPeriod) {
        <div class="w-full">
            <app-edit-gas-invoice #editGas [toast]="toast"
                [reloadCallbackFunction]="wrappedReloadCallback" [invoice]="firstInvoice"
                [listOfLocations]="listOfLocations"></app-edit-gas-invoice>
        </div>
        }

        <!-- Multiple invoices (bimestrale/trimestrale) -->
        @if (isMultiPeriod) {
        <!-- Bimestrale aggregated summary -->
        @if (bimestraleData) {
        <app-edit-bimestrale-summary [bimestraleData]="bimestraleData" [fileInvoices]="fileInvoices" [toast]="toast"
            [commodityType]="CommodityType.gas" (fileInvoicesChange)="fileInvoices = $event"
            (saved)="onBimestraleSaved()" (cancelled)="onBimestraleCancelled()">
        </app-edit-bimestrale-summary>
        }

        <!-- Per-period invoice cards -->
        @for (inv of fileInvoices; track inv.id; let idx = $index) {
        <div class="border border-neutral-200 rounded-lg mb-3">
            <div class="bg-neutral-100 px-4 py-3 rounded-t-lg flex items-center justify-between">
                <span class="font-bold text-lg">
                    {{ 'admin.period' | transloco }}: {{ formatPeriod(inv.for_period) }}
                </span>
                <div class="flex items-center gap-3">
                    <div class="w-[150px] h-[40px]">
                        <app-custom-button buttonText="{{ 'invoice.download_report' | transloco }}" [isDisabled]="false"
                            backgroundColor="bg-transparent" borderColor="border-transparent" textColor="text-black"
                            hoverBackgroundColor="hover:bg-neutral-400" hoverBorderColor="hover:border-transparent"
                            hoverTextColor="hover:text-black" leadingIcon="assets/icons/admin/download-black.svg"
                            (buttonClick)="downloadDisputeReport(inv)"
                            title="{{ 'invoice.download_report' | transloco }}">
                        </app-custom-button>
                    </div>
                    <span class="badge badge-sm bg-purple text-white px-3 py-2">
                        {{ bimestraleData?.invoice_period_type }}
                    </span>
                </div>
            </div>
            <div class="p-2">
                <app-edit-gas-invoice #editGas [toast]="toast"
                    [reloadCallbackFunction]="wrappedReloadCallback" [invoice]="inv"
                    [listOfLocations]="listOfLocations"></app-edit-gas-invoice>
            </div>
        </div>
        }
        }
        }
    </div>
</div>
